export default __webpack_public_path__ + "static/media/marketing_img_3.17afae76.jpg";